import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { HttpFileCopySource } from 'app/model/pipeline/copysource/http-file.copysource';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HttpFileCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        httpRequestTimeout: '*',
        maxConcurrentConnections: '*'
    }
})
export class HttpFileCopySourceAdapter extends CopySourceAdapter<HttpFileCopySource, Model.HttpSource> {
    protected override async _toResource(copySource: HttpFileCopySource): Promise<Model.HttpSource> {
        const result: Model.HttpSource = this.getCommonCopySourceProperties(copySource, 'HttpSource');
        result.httpRequestTimeout = ValueAdapter.toResource(copySource, HttpFileCopySource.REQUEST_TIMEOUT);
        result.maxConcurrentConnections = ValueAdapter.toResource(
            copySource,
            HttpFileCopySource.MAXCONCURRENT_CONNECTIONS
        );
        return result;
    }

    protected override async _toModel(
        httpSource: Model.HttpSource,
        copyActivity: CopyActivity
    ): Promise<HttpFileCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            HttpFileCopySource.MODEL,
            httpSource,
            copyActivity
        ) as HttpFileCopySource;
        ValueAdapter.toModel(result, HttpFileCopySource.MAXCONCURRENT_CONNECTIONS, httpSource.maxConcurrentConnections);
        ValueAdapter.toModel(result, HttpFileCopySource.REQUEST_TIMEOUT, httpSource.httpRequestTimeout);
        return result;
    }
}
